import type { Tracking } from "@ebay/experience-types-ebay";
import { composeAttrsForClickTracking } from "../../utils/tracking";

const LoadMoreClickId = "176699";

export const trackingData = (entryPageId?: string): Tracking => composeAttrsForClickTracking(LoadMoreClickId, "button", entryPageId);
